
import { Session, SessionKeys } from 'common/services/-RFC.session.js';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$rootScope', '$scope'];

class UsComplianceFailed {

    constructor($rootScope, $scope) {

        const initialUrl = String(Session.getValue(SessionKeys.InitialUrl));
        if (initialUrl.indexOf('client_id=spotlight') > -1) {

            $scope.showOkButton = true;
            if (window.external && ('CloseHtml' in window.external)) {

                $scope.closeHtml = () => {

                    window.external.CloseHtml('confirmed');

                };

            }

        }

        Mixpanel.send('ConnectWeb Restricted Page Open');
        $rootScope.State.finishedLoadingAnimation = true;
        $rootScope.State.loading = false;

    }

}

_serviceDependencies.push(UsComplianceFailed);

angular.module('controllers')
    .controller('UsComplianceFailed', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/us-compliance-failed/us-compliance-failed.js